import { createSlice } from '@reduxjs/toolkit'

export const userStore = createSlice({
    name: 'user-store',
    initialState: {
        loginState: localStorage.getItem('token') ? localStorage.getItem('token') : '',
        mode: localStorage.getItem('loginMode') ? localStorage.getItem('loginMode') : ''
    },
    reducers: {
        setUserLoginMode: (state, action) => {
            state.mode = action.payload
        },
        setUserLoginState: (state, action) => {
            state.loginState = action.payload
        }
    }
})

export const { setUserLoginMode, setUserLoginState } = userStore.actions
export default userStore.reducer